import styled from "styled-components";
import { DesignTokens } from "../common-ui/styles/design-tokens";
import { ElevationHelper } from "../common-ui/helper/ElevationHelper";

const { spacings } = DesignTokens;
const { createBoxShadowCSSString } = ElevationHelper;

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const TopArea = styled.div`
  flex: 1 1 50%;
  overflow: hidden;
  text-align: center;
  box-shadow: ${createBoxShadowCSSString({ level: 1 })};
  padding: ${spacings.xlarge}px;
`;

const ScrollableArea = styled.div`
  flex: 1 1 50%;
  overflow-y: auto;
  overflow-x: hidden;
`;

const ScrollableAreaContent = styled.div`
  width: 100%;
`;

type ProductScreenProps = {
  product: React.ReactNode;
  content: React.ReactNode;
};

export const ProductScreen: React.FC<ProductScreenProps> = ({
  product,
  content,
}) => (
  <Wrapper>
    <TopArea>{product}</TopArea>
    <ScrollableArea>
      <ScrollableAreaContent>{content}</ScrollableAreaContent>
    </ScrollableArea>
  </Wrapper>
);
